module.exports = __webpack_public_path__ + "static/media/messenger-notification.576ffd5c.wav";